import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_120_add_parts_issue: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Parts issue",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "parts_issue",
        TableName: "service_spare_part_issue",
        columnNumber: "m1 t1 w1",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        Fields: [
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Parts issue details",
            BindValue: "con_parts_issue_details",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "spare_issue_no",
                label: "SIN#",
                placeholder: "Will be auto generated...",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "spare_issue_no",
                disabled: true,
                AutoPopulate: true,
                AutoPopulate_format: "SPI_[******]",
              },
              // Issue date (required, DateTime)
              {
                componentType: ComponentType.DATE_FIELD,
                name: "issue_date",
                label: "Issue date",
                required: true,
                Json_Attribute: "issue_date",
                DefaultToday: true,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Issue date is required",
                  },
                ],
              },
              // Jobcard no (required, Search_Select)
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "parentid",
                label: "Jobcard no",
                placeholder: "",
                required: true,
                lookupName: "parts_issue_jobcard",
                options: [],
                searchable: true,
                clearable: true,
                Json_Attribute: "parent_id",
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Jobcard no is required",
                  },
                ],
              },
              // Customer name
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_customername",
                label: "Customer name",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "job_card_customername",
                disabled: true,
                BindParent: {
                  parentid: "customername",
                },
              },
              // Reg No.
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_reg_no",
                label: "Reg No.",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "job_card_reg_no",
                disabled: true,
                BindParent: {
                  parentid: "reg_no",
                },
              },
            ],
          },
          // SIN# (auto-generated, read-only)

          // Part details section with SubModule

          {
            componentType: ComponentType.SUB_MODULE,
            name: "service_spare_parts_issue",
            label: "Part details",
            tableName: "service_spare_parts_issue_details",
            lookupName: "Parts_request_Spareparts",
            parentField: "parentid",
            childControls: [
              // Hidden field: est_ref_id
              // {
              //   componentType: ComponentType.TEXT_FIELD,
              //   name: "est_ref_id",
              //   label: "",
              //   placeholder: "",
              //   required: false,
              //   inputType: InputType.TEXT,
              //   Json_Attribute: "est_ref_id",
              //   disabled: true,
              //   style: {
              //     display: "none",
              //   },
              // },
              // Code (Search_Select with product_itemcode lookup)
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_code",
                label: "Code",
                placeholder: "",
                required: false,
                lookupName: "product_itemcode",
                options: [],
                searchable: true,
                clearable: true,
                Json_Attribute: "codeid",
              },
              // Requested qty. (Numeric, read-only, default 0)
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_qty",
                label: "Requested qty.",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "qty",
                disabled: true,
                validation: [
                  {
                    rule: ValidationRule.CONDITION,
                    condition: "[qty] >= [issued_qty]",
                    message: "Issue quantity should be less or equal to requested quantity",
                  },
                ],
              },
              // Stock qty.
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_stock_qty",
                label: "Stock qty.",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "stock_qty",
                disabled: true,
                validation: [
                  {
                    rule: ValidationRule.CONDITION,
                    condition: "[stock_qty] > 0",
                    message:
                      "Some requested parts are out of stock. There are pending items to be issued. Kindly purchase the required items",
                    isWarning: true,
                  },
                ],
              },
              // Issued qty. (Numeric, default 0, with validation)
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_issued_qty",
                label: "Issue qty.",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "issued_qty",
                validation: [
                  {
                    rule: ValidationRule.PATTERN,
                    value: "^[0-9]*$",
                    message: "Only numbers are allowed",
                  },
                  {
                    rule: ValidationRule.CONDITION,
                    condition: "[issued_qty] <= [stock_qty]",
                    message: "Issued quantity should not be greater than stock quantity",
                    isWarning: true,
                  },
                ],
              },
              // Balance qty.
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_balance_qty",
                label: "Balance qty.",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "bal_qty",
                disabled: true,
                ExpressionV2: "[txt_qty] - [txt_issued_qty]",
              },
              // Rate (Numeric, read-only, expression: drp_code.sale_rate)
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_rate",
                label: "Rate",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "rate",
                disabled: true,
                ExpressionV2: "[drp_code.sale_rate]",
              },
              // Batch Rate
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_batch_rate",
                label: "Batch Rate",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "purchase_rate",
                disabled: true,
              },
              // Amount (Numeric, read-only, expression: txt_rate * txt_qty)
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_amount",
                label: "Amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "amount",
                disabled: true,
                ExpressionV2: "[txt_rate] * [txt_qty]",
              },
              // VAT% (Select with tax_rates lookup)
              {
                componentType: ComponentType.SELECT_DROPDOWN,
                name: "drp_vat",
                label: "VAT%",
                placeholder: "",
                required: false,
                lookupName: "tax_rates",
                options: [],
                Json_Attribute: "vat_id",
              },
              // Vat amt. (Numeric, read-only, expression)
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_vat_amt",
                label: "Vat amt.",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "vat_amt",
                disabled: true,
                ExpressionV2: "[txt_amount] * ([drp_vat.taxrate]/100)",
              },
              // Net amount (Numeric, read-only, expression)
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_net_amt",
                label: "Net amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "net_amt",
                disabled: true,
                ExpressionV2: "[txt_amount] + [txt_vat_amt]",
              },
              // Issued (Label, read-only, default "Pending")
              // {
              //   componentType: ComponentType.TEXT_FIELD,
              //   name: "issue_status",
              //   label: "Issued",
              //   placeholder: "",
              //   required: false,
              //   inputType: InputType.TEXT,
              //   defaultValue: "Pending",
              //   Json_Attribute: "issue_status",
              //   disabled: true,
              // },
            ],
          },
        ],
      },
      // Issue button
      {
        componentType: ComponentType.BUTTON,
        name: "Issue",
        onPressAction: "save",
        Navigate: "103",
        style: {
          backgroundColor: "var(--primary-green)",
        },
      },
    ],
  },
];
